<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    (matSortChange)="sortData($event)"
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--      NAME-->
    <ng-container
      matColumnDef="name"
      sticky
    >
      <th
        *matHeaderCellDef
        id="name"
        mat-header-cell
        mat-sort-header="name"
      >
        Organization Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
        <span (click)="openClinicDetails(eachRow)">{{ eachRow.name }}</span>
      </td>
    </ng-container>
    <!--      STATUS-->
    <ng-container
      matColumnDef="status"
    >
      <th
        *matHeaderCellDef
        id="status"
        mat-header-cell
        mat-sort-header="status"
      >
        Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            clientStatusColors[eachRow.status.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow.status.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      ORG TYPE-->
    <ng-container
      matColumnDef="orgType"
    >
      <th
        *matHeaderCellDef
        id="orgType"
        mat-header-cell
      >
        Organization Type
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem]"
          mat-cell>
        {{ getOrgList(eachRow.orgType) }}
      </td>
    </ng-container>
    <!--      GROUP COUNT-->
    <ng-container
      matColumnDef="groupCount"
    >
      <th
        *matHeaderCellDef
        id="groupCount"
        mat-header-cell
        mat-sort-header="groupCount"
      >
        <div
          class="pl-[12px]"
        >
          No. of Groups
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.groupCount }}
      </td>
    </ng-container>
    <!--      PARTICIPANT COUNT-->
    <ng-container
      matColumnDef="participantCount"
    >
      <th
        *matHeaderCellDef
        id="participantCount"
        mat-header-cell
        mat-sort-header="participantCount"
      >
        <div
          class="pl-[12px]"
        >
          No. of Participants
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.participantCount }}
      </td>
    </ng-container>
    <!--      AVERAGE ATTENDANCE-->
    <ng-container
      matColumnDef="averageAttendance"
    >
      <th
        *matHeaderCellDef
        id="averageAttendance"
        mat-header-cell
        mat-sort-header="averageAttendance"
      >
        <div
          class="pl-[12px]"
        >
          Average Attendance
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ (eachRow.averageAttendance || 0) | number:'1.0-2' }}%
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
